'use client'

import { searchQueryStringTypes } from "@/type/list"
import { useTranslations } from "next-intl"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"

export default function Search({totalCount, queryString, setQueryString, addQuery, setIsuserSearch}: {
    totalCount: number, 
    queryString: searchQueryStringTypes, 
    setQueryString: Function
    addQuery?: { [key: string]: any }
    setIsuserSearch?: React.Dispatch<React.SetStateAction<boolean>>
}){
    const [keyword, setKeyword] = useState<string>("")
    const [searchType, setSearchType] = useState<string>("title")

    const pathName = usePathname()

    const t = useTranslations('Text')
    
    function submitQueryString(){

        const setQuery: searchQueryStringTypes = {
            search_type: searchType,
            keyword: keyword,
            page: 1,
            page_count: queryString.page_count,
            ...addQuery
        }

        setIsuserSearch?.(true)
        setQueryString(setQuery)

        console.log("**** submitQueryString : ",setQuery, searchType, keyword );
    }

    useEffect(()=> {
        setKeyword('')
    }, [pathName])

    return (
        <>
        <div className={`search-container-new`}>
            <div>
                <select name="search-type" onChange={e=> setSearchType(e.currentTarget.value)}>
                    <option value="title">{t('제목')}</option>
                    <option value="content">{t('내용')}</option>
                </select>
                <input type="text" name="search" 
                    onKeyUp={e=> e.key == 'Enter' && submitQueryString()}
                    onChange={e=> setKeyword(e.currentTarget.value)}
                    value={keyword}
                    placeholder={t('검색어 입력')}/>
                <button onClick={submitQueryString}>
                    <img src="/icon/search_icon.png" />
                </button>
            </div>
        </div>
        </>
    )
}